import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  castErrorResult,
  CoursesApi,
  createSuccessResult,
  DrawerType,
  IApiError,
  IRydeProcess,
  Log,
  normalizeErrors,
  RydeProcessTitle,
  RydeUiUnit,
  SimpleResult,
  simpleResultErrorEmptyResponse,
  useDrawers,
} from "@ryde/shared";

const entity: RydeUiUnit = "course";

export const useCoursesBulkActions = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawers();

  const bulkDeepRecalculateCourses = useEvent(
    async (ids: number[]): Promise<SimpleResult<unknown>> => {
      if (!ids.length) {
        return createSuccessResult();
      }

      try {
        const bulkResult = await CoursesApi.bulkDeepRecalculateCourses({ ids });

        if (!bulkResult) {
          return simpleResultErrorEmptyResponse(t);
        }

        if (!bulkResult.success) {
          return castErrorResult(bulkResult);
        }

        const resultData = bulkResult.data as IRydeProcess;

        openDrawer<DrawerType.ProcessDrawer>({
          drawerProps: {
            type: DrawerType.ProcessDrawer,
            processId: resultData.id,
            processTitle: RydeProcessTitle.CourseDeepRecalculate,
            currentEntityPage: entity,
            entity,
          },
        });

        return bulkResult;
      } catch (error) {
        const normalizedError = normalizeErrors(error as IApiError, t);
        Log.errorAndToast(
          t("errors.errorPerformingBulkAction"),
          normalizedError,
        );
        return new SimpleResult({ error: normalizedError });
      }
    },
  );

  return {
    bulkDeepRecalculateCourses,
  };
};
